import Vue from 'vue';
import Vuex from 'vuex';
import { createStore } from 'vuex-extensions'
import user from './modules/user';
import generalState from './modules/generalState';

Vue.use(Vuex);

export default createStore(Vuex.Store, {
    modules: {
        general: generalState,
        user: user,
    },
})
